export default __webpack_public_path__ + "b8b84555e3a51b5ef0c7bac9520281e5.png";